export const API_BASE_URL = "https://api.fastmate.app/aiut251";
export const WEB_FUNNEL_URL = "#";
export const ANDROID_URL = "#";
export const IOS_URL = "#";

export const FREE_EMAILS_LIST = API_BASE_URL + "";
export const GET_GENERAL_PAGES = API_BASE_URL + "/pre/general/pages";
